<template>
<div class="recognize">
	<div class="title">申请信息</div>
	<Form 
		:model="baseInfo" 
		:label-width="125" 
		ref="form"
		class="mt15">
		<FormItem 
			label="保障起期：" class="w600"
			prop="effectiveDateStart"
			:rules="{required:true,message:'请选择保障起期',type:'date',trigger:'blur'}">
			<DatePicker 
				v-model="baseInfo.effectiveDateStart" 
				type="date" 
				placeholder="请选择保障起期" 
				style="width: 300px" 
				@on-change="dateChange"
				:options="dateOptions">
			</DatePicker>
		</FormItem>
		<FormItem 
			label="保障止期：" class="w600"
			prop="effectiveDateEnd"
			:rules="{required:true,message:'请选择保障止期',type:'date',trigger:'blur'}">
			<DatePicker 
				v-model="baseInfo.effectiveDateEnd" 
				type="date" 
				placeholder="请选择保障止期" 
				style="width: 300px" 
				@on-change="dateEndChange"
				:options="endDateOptions">
			</DatePicker>
		</FormItem>
		<FormItem 
			label="保障天数：" class="w600">
			{{days}}天
		</FormItem>
		<FormItem 
			label="方案：" class="w600">
			{{scheme}}
		</FormItem>
	</Form>
	<p class="download-info mt15">
		<a :href="`/pc/broker/insurance/application/template/export/${bizId}/${baseInfo.productCode}`" target="_blank">下载登记表</a>
		<span class="tips">确认参加本计划人员信息后再上传</span>
	</p>
	<div class="download-btn mt15">
		<UploadFile	
			:data="uploadParams"
			:disabled="!Boolean(baseInfo.effectiveDateStart&&baseInfo.effectiveDateEnd)"
			url="/pc/broker/quote/byImport"
			:show-upload-list="false"
			@on-success="handleSuccess" />
	</div>
	<div class="recognize mt15">
		<div class="recognize-title">参加人员信息</div>
		<p class="recognize-total mt10">共{{list.length}}人，费用：{{baseInfo.premium}}元</p>
		<div class="recognize-table mt10">
			<SchemeTable type="person" />
			<e-table :list="list">
				<el-table-column prop="no" label="序号" width="70" align="center" fixed></el-table-column>
				<el-table-column prop="scheme" label="保障方案" show-overflow-tooltip min-width="180"></el-table-column>
				<el-table-column prop="premium" label="保费（元）" min-width="120"></el-table-column>
				<el-table-column prop="insuredPersonName" label="姓名" min-width="100"></el-table-column>
				<el-table-column prop="idCard" label="证件号码" min-width="190"></el-table-column>
				<el-table-column prop="gender" label="性别" min-width="70"></el-table-column>
				<el-table-column prop="age" label="年龄" min-width="70"></el-table-column>
				<el-table-column prop="msg" label="情况说明" min-width="100">
					<template slot-scope="{ row }">
						<span style="color:red" v-if="!row.checkResult.empty">
							{{row.checkResult.result}}
						</span>
						<span style="color:green" v-else>
							校验通过
						</span>
					</template>
				</el-table-column>
			</e-table>
		</div>
		<div class="recognize-title mt15" v-if="identityType=='PERSON'">参加人员雇佣合同
			<span class="tips">先确认参加人员后，再根据参加人员上传雇佣合同，无相关材料人员出险后保险公司有权拒赔。</span>
		</div>
		<div class="recognize-upload mt10" v-if="identityType=='PERSON'">
			<div class="recognize-upload-item">
				<UploadFileImg @on-success="uploadSuccess" >
					<div class="mt10">
						<Icon type="ios-cloud-upload-outline" size="20" />
						<p>{{subjectMatterUrls?'重新':''}}上传雇佣合同</p>
					</div>
					<a :href="subjectMatterUrls" target="_blank" v-if="subjectMatterUrls" @click.stop>查看</a>
				</UploadFileImg>
			</div>
			<span class="tips">新增{{list.length}}人，请上传包含这{{list.length}}人雇佣合同的压缩文件。</span>
		</div>
	</div>
</div>
</template>
<script>
import UploadFile from '../../common/UploadFile'
import SchemeTable from '../common/SchemeTable'
import UploadFileImg from '@/components/common/UploadFileImg'
import eTable from '@/components/common/eTable'
export default {
	components:{ UploadFile,SchemeTable,UploadFileImg,eTable },
	props:{
		info:{
			type:Object,
			default(){
				return {}
			}
		},
        bizId:{
            type:String,
            default:''
        },
	},
	data () {
		return {
			list:[],
			baseInfo:{},
			subjectMatterUrls:'',
			dateOptions:{
				disabledDate (date) {
					return date&&(date.valueOf()<Date.now())
				}
			},
			endDateOptions:{},
			scheme:this.$route.query.scheme
		}
	},
	computed:{
		days(){
			if(this.baseInfo.effectiveDateStart&&this.baseInfo.effectiveDateEnd){
				return this.getDays(this.formatDate(this.baseInfo.effectiveDateStart),this.formatDate(this.baseInfo.effectiveDateEnd));
			}else {
				return ""
			}
		},
		/*校验是否上传了投保人员*/
		tableFlag () {
			let flag = true;
			this.list.map(item=>{
				if(!item.checkResult.empty){
					flag = false;
				}
			})
			return this.list.length>0&&flag;
		},
		uploadParams(){
			return {
				productCode:this.baseInfo.productCode,
				bizId:this.bizId,
				effectiveDateStart:this.formatDate(this.baseInfo.effectiveDateStart),
				effectiveDateEnd:this.formatDate(this.baseInfo.effectiveDateEnd),
				extendField1:this.scheme,
				applicantId:this.info.applicantInfo.enterpriseId
			}
		},
		identityType(){
			return this.info.applicantInfo?this.info.applicantInfo.identityType:''
		},
	},
	watch:{
		info: {
			handler(res) {
				this.initData();
			},
			immediate:true
		},
		'info.effectiveDateStart'(){
			this.setEndDateOptions()
		}
	},
	created(){
		if(this.baseInfo.effectiveDateStart){
			this.setEndDateOptions()
		}
	},
	methods:{
		initData(){
			this.baseInfo={
				insuranceApplicationId:this.info.insuranceApplicationId,
				effectiveDateStart:this.info.effectiveDateStart,
				effectiveDateEnd:this.info.effectiveDateEnd,
				productCode:this.info.productCode,
				premium:this.info.premium,
			}
			if(this.baseInfo.effectiveDateStart)this.baseInfo.effectiveDateStart=new Date(this.baseInfo.effectiveDateStart);
			if(this.baseInfo.effectiveDateEnd)this.baseInfo.effectiveDateEnd=new Date(this.baseInfo.effectiveDateEnd);
			if(this.info.subjectMatter&&this.info.subjectMatter.length>0){
				this.list=this.info.subjectMatter.map(item=>{
					item.checkResult={empty:true}
					return item
				})
			}
			if(!this.subjectMatterUrls)this.subjectMatterUrls=this.info.subjectMatterUrls
		},
		// 保障止期限制
		setEndDateOptions(){
			const that=this;
			let nextYearDay=this.getAfterDay(1,this.baseInfo.effectiveDateStart)
			this.endDateOptions={
				disabledDate (date) {
					return date&&
					(date.valueOf()<=Date.parse(that.baseInfo.effectiveDateStart))||
					(date.valueOf()>Date.parse(nextYearDay))
				}
			}
		},
		/*日期变化后获取起保终保日期*/
		dateChange (value) {
			if(Date.parse(this.baseInfo.effectiveDateEnd)&&Date.parse(value)>=Date.parse(this.baseInfo.effectiveDateEnd)){
				this.$set(this.baseInfo,'effectiveDateEnd','')
			}
			if(value){
				this.setEndDateOptions()
			}
			this.getPremium();
		},
		/*日期变化后获取起保终保日期*/
		dateEndChange (value) {
			this.getPremium();
		},
		/*上传成功后获取数据*/
		handleSuccess (res) {
			this.list = res.data.subjectMatter;
			this.$set(this.baseInfo,'premium',res.data.premium)
			this.$emit('set-amount',res.data.premium)
		},
		/*获取保费*/
		getPremium () {
			if(!this.baseInfo.effectiveDateStart||!this.baseInfo.effectiveDateEnd||this.list.length==0||!this.tableFlag)return;
			let form={
				effectiveDateStart:this.formatDate(this.baseInfo.effectiveDateStart),
				effectiveDateEnd:this.formatDate(this.baseInfo.effectiveDateEnd),
				productCode:this.baseInfo.productCode,
				subjectMatter:this.list,
				bizId:this.bizId,
				applicantList:[this.info.applicantInfo]
			}
			this.$axios.post('/broker/quote.json.dst',form).then(res=>{
				this.$set(this.baseInfo,'premium',res.premium)
				this.list=res.subjectMatter;
				this.$emit('set-amount',res.premium)
			})
		},
		// 上传回调方法
		uploadSuccess(val){
			this.subjectMatterUrls=val.url
		},
		// 提交
		async sub () {
			if(!await this.$refs.form.validate()){
				this.toast('请填写正确的申请信息','error')
				return false
			}
			if(!this.tableFlag){
				this.toast(this.list.length==0?'请上传参加人员信息':'参加人员信息校验失败','error')
				return false
			}
			if(this.identityType=='PERSON'&&!this.subjectMatterUrls){
				this.toast('请上传雇佣合同','error')
				return false
			}
			return {
				...this.baseInfo,
				effectiveDateStart:this.formatDate(this.baseInfo.effectiveDateStart),
				effectiveDateEnd:this.formatDate(this.baseInfo.effectiveDateEnd),
				subjectMatterUrls:this.identityType=='PERSON'?this.subjectMatterUrls:'',
				subjectMatter:this.list,
				extendField1:this.scheme
			}
		},
	}
}
</script>
<style scoped lang="less">
	.download-info{
		font-size: 14px;
	}
	.recognize{
		&-title{
			font-weight: bold;
			font-size: 14px;
		}
		&-total{
			font-size: 14px;
		}
		.tips{
			color:#FF9900;
			margin-left: 20px;
			font-size: 14px;
		}
		&-upload{
			&-item{
				width: 200px;
				text-align: center;
				display: inline-block;
				vertical-align: top;
				font-size: 14px;
				a{
					font-size: 14px;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/truckEmployer/person/Recognize.vue